import { useMutation, useQuery } from '@tanstack/react-query';
import { useContext, useEffect } from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { AppContext } from '../containers/appContextContainer';
import { TilbakemeldingWeb } from '../generated-types';
import errorTypes from '../util/gtm/errorTypes';
import restClient from '../util/web-http-client';

export const useKvitteringInfo = (soeknadId: string) => {
    const { setError } = useContext(AppContext);
    const query = useQuery({
        queryKey: ['kvitttering', soeknadId],
        queryFn: () => restClient.getKvitteringInfo(soeknadId),
        retry: 1,
    });

    useEffect(() => {
        if (query.error) {
            setError({
                errorType: errorTypes.GET_KVITTERING_INFO,
                errorException: query.error as RequestExceptionWithResponse,
            });
        }
    }, [query.error, setError]);

    return query;
};

export const useSaveTilbakemelding = (successCallback?: () => void) => {
    const { setError } = useContext(AppContext);
    return useMutation({
        mutationKey: ['saveTilbakemelding'],
        mutationFn: (tilbakemelding: TilbakemeldingWeb) => restClient.saveTilbakemelding(tilbakemelding),
        onSuccess: (data: boolean) => {
            if (data && successCallback) {
                successCallback();
            }
        },
        onError: (error: unknown) => {
            setError({
                errorType: errorTypes.SAVE_TILBAKEMELDING,
                errorException: error as RequestExceptionWithResponse,
            });
        },
    });
};
